import axios from "axios";

const api = axios.create({
  baseURL: "https://medical-backend-cgj8.onrender.com/api/",
});

// Interceptor: Automatically attach token — BUT DO NOT force Content-Type
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // If it's FormData, let browser set headers
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  return config;
});

export default api;
